import i18n from '@atpoint/atpjs/helpers/i18n'
import { Component } from 'react'

class NotFound extends Component {
  render() {
    const t = i18n.prefix(['not_found'])
    return (
      <div>
        <h4>{t(['title'])}</h4>
      </div>
    )
  }
}

export default NotFound
